import NonPcnService from './service';
import { GetNonPcnResponseData } from './types';

export const NON_PCN_QUERY_KEYS = {
  GET_NON_PCN: 'GET_NON_PCN',
};

export class NonPcnQueries {
  public static readonly getNonPcn = async (
    projectID: number,
    requestID: number,
    version: number
  ): Promise<GetNonPcnResponseData> => {
    const { data } = await NonPcnService.getNonPcn(projectID, requestID, version);
    return data;
  };
}
